import React from 'react'

export default function Personal() {
    return (
        <div>
            <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.75008 52.4998H61.2501V14.5832C61.2501 13.8096 60.9428 13.0678 60.3958 12.5208C59.8488 11.9738 59.107 11.6665 58.3334 11.6665H11.6667C10.8932 11.6665 10.1513 11.9738 9.60435 12.5208C9.05737 13.0678 8.75008 13.8096 8.75008 14.5832V52.4998ZM5.83341 58.3332H64.1667C67.0834 58.3332 67.0834 55.4165 67.0834 55.4165H2.91675C2.91675 55.4165 2.91675 58.3332 5.83341 58.3332Z" stroke="#BB0600" stroke-width="5" />
            </svg>

        </div>
    )
}
